import React from 'react';

interface ActiveGameViewProps {
  activeGameUrl: string | null;
  onClose: () => void;
}

export const ActiveGameView: React.FC<ActiveGameViewProps> = ({ activeGameUrl, onClose }) => {
  if (!activeGameUrl) return null;

  return (
    <div className="pwa-game-overlay">
      <div className="pwa-game-header">
        <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, marginRight: '20px' }}>
          {activeGameUrl}
        </div>
        <button
          onClick={onClose}
          style={{ background: '#ef4444', border: 'none', color: '#fff', padding: '6px 12px', borderRadius: '8px', fontWeight: '800', fontSize: '10px', cursor: 'pointer' }}
        >
          CLOSE
        </button>
      </div>
      <iframe
        src={activeGameUrl}
        className="pwa-game-iframe"
        title="Game Launcher"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      />
    </div>
  );
};
